import { formatDate, handleImageError } from "helpers/globalFunction";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Zoom from "react-medium-image-zoom";

const DetailModalEvent = ({ show, onCloseClick, data }: any) => {
  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="md"
    >
      <ModalHeader
        // className="border-0 bg-primary text-white"
        className="bg-light p-3"
        toggle={onCloseClick}
      >
        <span className="fw-semibold">Detail Event</span>
      </ModalHeader>
      <ModalBody className="p-4" style={{ background: "#f8f9fa" }}>
        <div className="bg-white rounded p-3 mb-3 shadow-sm">
          <Zoom>
            <img
              src={data?.picture}
              onError={handleImageError}
              className="w-100 rounded"
              style={{
                objectFit: "cover",
                maxHeight: "280px",
              }}
              alt="Event"
            />
          </Zoom>
        </div>

        <div className="d-flex flex-column gap-2">
          <div className="bg-white rounded p-3 shadow-sm">
            <div className="text-muted small mb-1">Waktu Kehadiran</div>
            <div className="fw-semibold">
              {formatDate(data?.createTime, "fullDateTime")}
            </div>
          </div>

          <div className="bg-white rounded p-3 shadow-sm">
            <div className="text-muted small mb-1">Nama Karyawan</div>
            <div className="fw-semibold">{data?.member?.name}</div>
          </div>

          <div className="bg-white rounded p-3 shadow-sm">
            <div className="text-muted small mb-1">No Reg Karyawan</div>
            <div className="fw-semibold">{data?.member?.noId}</div>
          </div>

          <div className="bg-white rounded p-3 shadow-sm">
            <div className="text-muted small mb-1">Keterangan</div>
            <div
              className="fw-semibold"
              style={{
                wordBreak: "break-word",
                maxHeight: "150px",
                overflowY: "auto",
              }}
            >
              {data?.note || "-"}
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

DetailModalEvent.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  data: PropTypes.object,
};

export default DetailModalEvent;
